import { Flex } from 'antd';
import { useTranslation } from 'react-i18next';
import { spacing } from '../../theming';
import { errorTags } from '../../utils/vinExtraction';
import { attemptCardStyle, candidateVinStyle, labelStyle, mutedSmallStyle } from './vinExtractionStyles';
import ErrorCodeTags from './ErrorCodeTags';
import NoValue from './NoValue';
import AttemptConfidence from './AttemptConfidence';
import AttemptHeader from './AttemptHeader';
import AttemptModel from './AttemptModel';

/**
 * One extraction attempt: kind and number (+ "Latest"), time, the candidate VIN as text only, confidence against
 * the batch's threshold (E17: a legacy batch shows the current one, marked so), error codes and messages, model.
 */
export default function AttemptCard({ attempt, latest, highlighted, threshold, thresholdIsCurrent }) {
    const { t } = useTranslation('vinExtraction');
    const messages = attempt.validationErrors.filter(error => error.message);

    return (
        <Flex
            vertical
            gap={spacing[1]}
            style={attemptCardStyle(highlighted)}
            data-testid="vin-attempt-card"
            role="group"
            aria-label={t(`drawer.attempt.kind.${attempt.kind}`, { number: attempt.attemptNumber })}
        >
            <AttemptHeader attempt={attempt} latest={latest} />
            <Flex vertical>
                <span style={labelStyle}>{t('drawer.attempt.candidate')}</span>
                <span style={candidateVinStyle}>
                    {attempt.candidateVin ?? <NoValue label={t('drawer.attempt.noCandidate')} />}
                </span>
            </Flex>
            <AttemptConfidence attempt={attempt} threshold={threshold} thresholdIsCurrent={thresholdIsCurrent} />
            <Flex wrap="wrap" gap={spacing[0.5]} aria-label={t('drawer.attempt.errors')} role="group">
                <ErrorCodeTags tags={errorTags(attempt)} />
            </Flex>
            {messages.map((error, index) => (
                <span key={`${error.code}-${index}`} style={mutedSmallStyle}>
                    {error.message}
                </span>
            ))}
            <AttemptModel model={attempt.model} />
        </Flex>
    );
}
